import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=1479ef64&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=1479ef64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479ef64",
  null
  
)

export default component.exports